<template>
    <div class="app_container">
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">

                <el-form-item>
                    <el-input v-model="form.keyword" placeholder="请输入关键字" @keyup.enter.native="loadData"  :inline="true"></el-input>
                </el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>


            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/iconAdd' ,query: { callback:request }}">
                    <el-button type="primary">创建</el-button>
                </router-link>
            </div>
            <el-table :data="tableData" v-loading="loading" >
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>

                <!--<el-table-column label="编号" prop="serialNumber"></el-table-column>-->
                <el-table-column label="图标名称" prop="title"></el-table-column>

                <el-table-column label="图标类型" prop="iconType">
                    <template slot-scope="scope">{{scope.row.iconType|tableVal(iconType)}}</template>
                </el-table-column>
                <el-table-column label="图标" prop="icon">
                    <template slot-scope="scope">
                        <img :src="scope.row.url" alt="" style="width: 30px;height: 30px;display: block">
                    </template>
                </el-table-column>

                <el-table-column label="创建时间" prop="createTime" width="150"></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <el-button class="table-del-btn" type="text" @click="deleteRole(scope.row)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>

    </div>
</template>

<script>
    // import {statusLists} from './change.config'
    import services from "./system.service"
    export default {
        data() {
            return {
                form:{
                    // changeStatus:'',
                    keyword:"",
                    pageSize:10,
                    pageIndex:1,
                },
                total:null,
                // tableData:[
                //     {
                //         title:'默认',
                //         iconType:'系统图标',
                //         url:require('../../assets/gj_end.png'),
                //         id:'3',
                //         createTime:'2019-7-11 00:00:00',
                //     }
                // ],
                tableData:[],
                loading:true,

                ExportBtn:false,
            }
        },
        created() {

            this.request();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            iconType(){
                return this.dictionary.icon_type
            }
            // changeStatus(){
            //     return this.dictionary.change_status;
            // }
        },
        methods: {
            loadData(){
                this.form.pageIndex = 1;
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                this.request();
            },
            request(){
                // // 获取列表数据
                // console.log(this.dictionary,'字典');

                // console.log(this.form,'这是changeManage里的request请求前，打印this.form');
                services.getIconList(this.form).then(res => {
                    // console.log(res,'这是iconManage里的request请求后，打印res');
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    // console.log(1);
                    this.loading = false;
                })
            },
            deleteRole(row){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.deleteIcon({ id:row.id }).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            }
        }
    }
</script>

<style scoped>

</style>
